// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HqiAC9HKP4u26pF4WO6s[data-has-many='true'] {
  font-size: var(--campaign-prize-fund-currency-has-many);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .HqiAC9HKP4u26pF4WO6s[data-has-many='true'] {
    height: 100%;
    font-size: var(--campaign-prize-fund-currency-has-many-mobile);
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  /* .currency is a descendant of .subtitleContainer (via the inner .subtitleTextWrapper,
     see RebateSubtitleCampaign.tsx), which itself carries these attributes — group under it. */
  .Hr1NbYTdpe52hBuSVsR4[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) {
    font-size: var(--campaign-prize-fund-font-has-many-multi-portrait);
  }
  .Hr1NbYTdpe52hBuSVsR4[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) .HqiAC9HKP4u26pF4WO6s {
    font-size: var(--campaign-prize-fund-currency-has-many-multi);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  /* .currency is a descendant of .subtitleContainer (via the inner .subtitleTextWrapper,
     see RebateSubtitleCampaign.tsx), which itself carries these attributes — group under it. */
  .Hr1NbYTdpe52hBuSVsR4[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) {
    font-size: var(--campaign-prize-fund-font-has-many-multi-portrait);
  }
  .Hr1NbYTdpe52hBuSVsR4[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) .HqiAC9HKP4u26pF4WO6s {
    font-size: var(--campaign-prize-fund-currency-has-many-multi);
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/shared/RebateSubtitleCampaign/css/hasManyStyles.module.css"],"names":[],"mappings":"AAAA;EACE,uDAAuD;AACzD;AACA;EACE;IACE,YAAY;IACZ,8DAA8D;EAChE;AACF;AACA;AAAA;EACE;+FAC6F;EAC7F;IACE,kEAAkE;EACpE;EACA;IACE,6DAA6D;EAC/D;AACF;AAAA;AATA;AAAA;AAAA;AAAA;EACE;+FAC6F;EAC7F;IACE,kEAAkE;EACpE;EACA;IACE,6DAA6D;EAC/D;AACF;AAAA;AAAA;AAAA","sourcesContent":[".currency[data-has-many='true'] {\n  font-size: var(--campaign-prize-fund-currency-has-many);\n}\n@media (--campaign-mobile) {\n  .currency[data-has-many='true'] {\n    height: 100%;\n    font-size: var(--campaign-prize-fund-currency-has-many-mobile);\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) and (--campaign-tablet-portrait-rule) {\n  /* .currency is a descendant of .subtitleContainer (via the inner .subtitleTextWrapper,\n     see RebateSubtitleCampaign.tsx), which itself carries these attributes — group under it. */\n  .subtitleContainer[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) {\n    font-size: var(--campaign-prize-fund-font-has-many-multi-portrait);\n  }\n  .subtitleContainer[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) .currency {\n    font-size: var(--campaign-prize-fund-currency-has-many-multi);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"currency": `HqiAC9HKP4u26pF4WO6s`,
	"subtitleContainer": `Hr1NbYTdpe52hBuSVsR4`
};
export default ___CSS_LOADER_EXPORT___;
